module.exports={
  "news_close": {
    "id": "news_close",
    "eventName": "fechar_news",
    "eventProduct": "institucional",
    "eventCategory": "vexpenses",
    "eventAction": "News",
    "eventValue": 0
  },
  "news_link": {
    "id": "news_link",
    "eventName": "clique_news",
    "eventProduct": "institucional",
    "eventCategory": "vexpenses",
    "eventAction": "News",
    "eventValue": 0
  }
}
